const links = [
    {
        label: 'Sobre mim',
        url: '/about'
    },
    {
        label: 'Blog',
        url: '/blog'
    },
    {
        label: 'Contato',
        url: '/contato'
    }
]

export default links;